import { Avatar, Box, Card, CardContent, Grid2, IconButton, Stack, Typography, useTheme } from "@mui/material";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCostProgressCurveQuery } from "store/slices/apis/costSlice";

// const data = [
//     {
//         label: 'Planed Value',
//         value: 650
//     },
//     {
//         label: 'Actual Cost',
//         value: 750
//     },
//     {
//         label: 'Earned Value',
//         value: 600
//     }
// ];
// const categories = [
//     "Jul,24",
//     "Aug,24",
//     "Sep,24",
//     "Oct,24",
//     "Nov,24",
//     "Dec,24",
//     "Jan,25",
//     "Feb,25",
//     "Mar,25",
//     "Apr,25",
//     "May,25",
//     "Jun,25",
//     "Jul,25",
//     "Aug,25",
//     "Sep,25",
//     "Oct,25"
// ];
// // Data series for Actual, Plan
// const actualData = [0.45, 1.62, 3.97, 8.75, 15.7, 25.68, 38.86, 52.62, 65.6, 75.54];
// const planData = [0.5, 1.7, 4.1, 8.9, 15.9, 25.9, 38.9, 52.9, 65.9, 75.9, 83.9, 89.9, 93.9, 96.9, 98.9, 100];


const FinancialProgressSCurve = (props) => {
    const { earnValueData } = props
    const theme = useTheme();

    const { projectId } = useParams();
    const navigate = useNavigate();
    const [category, setCategory] = useState([]);
    const [actualLineColor, setActualLineColor] = useState(null);
    const [actualData, setActualData] = useState([]);
    const [planData, setPlanData] = useState([]);
    const costProgressRes = useGetCostProgressCurveQuery({ projectId });

    useEffect(() => {
        if (costProgressRes?.isSuccess) {
            const actualValue = costProgressRes?.data?.data?.map((item) => item?.actualCumulative > 0 ? item?.actualCumulative : null);
            const planValue = costProgressRes?.data?.data?.map((item) => item?.plannedCumulative > 0 ? item?.plannedCumulative : null);

            const actualTotal = actualValue.reduce((a, b) => a + b, 0);
            const planTotal = planValue.reduce((a, b) => a + b, 0);

            const actualColor = actualTotal >= planTotal ? '#3E756D' : '#E72B33';
            setActualLineColor(actualColor);
            setActualData(actualValue);
            setPlanData(planValue);
            setCategory(costProgressRes?.data?.data?.map((item) => item?.month));

        }
        earnValueData(costProgressRes);
    }, [costProgressRes])

    const options = {
        chart: { type: "spline", height: 375 },
        // colors: ["#295477", "#377E36"],
        title: { text: "" },
        xAxis: {
            categories: category,
            title: { text: 'Months' },
            labels: {
                style: {
                    fontSize: '10px',
                    fontWeight: 500,
                    color: '#414D55'
                }
            }
        },
        yAxis: {
            title: { text: 'Progress Percentage' },
            gridLineWidth: 1,
            min: 0
            // tickPositioner: function () {
            //     let positions = [0];
            //     for (let i = 10; i <= 100; i += 10) {
            //         positions.push(i);
            //     }
            //     return positions;
            // },
        },
        legend: {
            align: "left",
            verticalAlign: "top",
            layout: "horizontal",
            itemDistance: 20,
            useHTML: true,
            symbolWidth: 0,
            x: -20,
            itemMarginBottom: 40,
            labelFormatter: function () {
                return `<span style="display: inline-block; width: 13px; height: 13px; background-color: ${this.color}; margin-right: 5px;"></span> <span style="font-size:15px; font-weight:500, color:#00000080">${this.name}</span>`;
            },
        },
        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: () => {
                            localStorage.setItem("costTabIndex", 0);
                            navigate(`/projects/${projectId}?type=cost`);
                        }
                    }
                },
            },
        },
        tooltip: {
            shared: true,
            useHTML: true,
            backgroundColor: "#00000080",
            showdow: false,
            formatter: function () {
                let tooltipHtml = ``;
                this.points.forEach((point) => {
                    tooltipHtml += `<b>${point.series.name}: ${point.y ?? 0}</b><br/>`;
                });

                return tooltipHtml;
            },
            style: {
                color: '#fff'
            }
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: "Planned Cost",
                data: planData,
                color: '#295477',
                marker: { enabled: false, symbol: "circle" },
                lineWidth: 3,
            },
            {
                name: "Actual Cost",
                data: actualData,
                color:actualLineColor,
                marker: { enabled: false, symbol: "circle" },
                lineWidth: 3,
            },
        ],
    };

    return (
        <Box sx={{ padding: 2, pb: 0, border: '1px solid #2525252E', borderRadius: '7px', background: "#FFFFFF" }}>
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ mb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                    Financial Progress - S Curve
                </Typography>
                <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '14px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                    Planned versus actual financial progress to evaluate cost performance and forecast accuracy
                </Typography>
            </Grid2>
            <Grid2 size={{ md: 12 }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </Grid2>
        </Box>
    );
};

export default FinancialProgressSCurve;
